import * as types from "./ActionsOverlayReducer";

export default function userReducer(
    state = {
        overlay: {
            show: false,
            text: ""
        }
    }, action: any) {
    switch (action.type) {
        case types.SHOW_OVERLAY:
            state.overlay = {
                show: true,
                text: action.text
            };
            break;
        case types.HIDE_OVERLAY:
            state.overlay = state.overlay = {
                show: false,
                text: ""
            };
            break;
    }

    return { ...state };
}



// WEBPACK FOOTER //
// ./src/app/stores/reducers/overlay/OverlayReducer.ts